import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { Edit, useTranslate } from 'react-admin'
import { useFormState } from 'react-hook-form'
import { makeStyles } from 'tss-react/mui'
import { injectElement, reduceProps } from '~/helpers'

/**
 * react-hook-form has no <FormSpy>; isDirty is read from the form state
 * and pushed up through an effect instead.
 */
const DirtyWatcher = ({ onDirtyChange }) => {
  const { isDirty } = useFormState()
  React.useEffect(() => {
    onDirtyChange(isDirty)
  }, [isDirty, onDirtyChange])
  return null
}

/*
 * Custom css for dialog
 */
const useStyles = makeStyles()({
  scrollPaper: {
    alignItems: 'baseline',
  },
  root: {
    '& div.MuiDialogContent-root': {
      padding: 0,
    },
  },
})

/*
 * EditModal
 */
const EditModal = (props) => {
  const { fullWidth, title, children, state, onClose, ...rest } = props
  const [open, setOpen] = state
  const translate = useTranslate()
  const [dirtyState, setDirtyState] = React.useState(false)

  const handleClose = () => {
    if (dirtyState) {
      if (window.confirm(translate('ra.message.unsaved_changes')))
        state ? setOpen(false) : onClose()
    } else {
      state ? setOpen(false) : onClose()
    }
  }

  let finalTitle = title
  if (!finalTitle) {
    const resourceName = translate(`resources.${rest.resource}.name`, { smart_count: 1 })
    finalTitle = `${resourceName} #${rest.id}`
  }

  const inject = <DirtyWatcher onDirtyChange={setDirtyState} />

  return (
    <Dialog
      // fullWidth={fullWidth}
      open={open}
      onClose={handleClose}
      aria-label={finalTitle}
      classes={useStyles()}
      maxWidth='md'
      fullWidth={true}
    >
      <DialogTitle>{finalTitle}</DialogTitle>
      <DialogContent>
        <Edit {...reduceProps(rest)} component='div' redirect={false}>
          {injectElement(children, inject, ['SimpleForm', 'FormTab'])}
        </Edit>
      </DialogContent>
    </Dialog>
  )
}

export default EditModal
